import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource, MatTable } from '@angular/material/table';
import { NgxSpinnerService } from 'ngx-spinner';
import { BaseDto } from '@models/base/baseDto.model';
import { AccionesDialog, TiposBonificaciones } from '@models/base/identificadores.model';
import { TipoBonificacionDto } from '@models/bonificaciones/tipoBonificacionDto.model';
import { CreateTipoBonificacionRequest } from '@models/bonificaciones/createTipoBonificacionRequest.model';
import { UpdateTipoBonificacionRequest } from '@models/bonificaciones/updateTipoBonificacionRequest.model';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { TiposBonificacionService } from '@services/tipos-bonificacion/tipos-bonificacion.service';
import { DialogTipoBonificacionComponent } from '../dialog-tipo-bonificacion/dialog-tipo-bonificacion.component';
import { DialogDescripcionComponent } from '@views/dialog-basic/dialog-descripcion/dialog-descripcion.component';
@Component({
  selector: 'app-tipos-bonificacion',
  templateUrl: './tipos-bonificacion.component.html',
  styleUrls: ['./tipos-bonificacion.component.css']
})
export class TiposBonificacionComponent implements OnInit {

  data = false
  dataSource = new MatTableDataSource<TipoBonificacionDto>();
  obj!: undefined
  displayedColumns: string[] = [];
  detalle!: string;
  @ViewChild(MatTable, { static: true }) table!: MatTable<any>;

  private paginator!: MatPaginator;
  private sort!: MatSort;

  @ViewChild(MatSort) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }

  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }

  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    if (this.paginator && this.sort) {
      this.applyFilter(null);
    }
  }

  constructor(
    public dialog: MatDialog,
    private tiposBonificacionService: TiposBonificacionService,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
    private breakpointObserver: BreakpointObserver
  ) {
    this.breakpointObserver.observe(['(max-width: 600px)']).subscribe(result => {
      this.displayedColumns = result.matches ?
        ['descripcion', 'comision', 'accion'] :
        ['descripcion', 'comision', 'detalle', 'accion'];
    });

  }


  ngOnInit() {
    this.getTiposPunitorios();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  getTiposPunitorios() {
    this.spinner.show()
    this.tiposBonificacionService.getAll()
      .subscribe(
        data => {
          this.spinner.hide()
          this.dataSource.data = data.sort((a, b) => a.descripcion.toString().localeCompare(b.descripcion.toString()))
          this.data = this.dataSource.data.length >= 1 ? true : false
        },
        error => {
          this.snackBar.showError(error, "Error");
          this.spinner.hide()
        }
      )
  }

  openDialog(action: any, obj: { action?: any; }) {
    obj.action = action;

    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false;
    dialogConfig.data = obj

    const dialogRef = this.dialog.open(DialogTipoBonificacionComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.event == AccionesDialog.Agregar) {
        this.addRowData(result.data);
      } else if (result && result.event == AccionesDialog.Modificar) {
        this.updateRowData(result.data);
      } else if (result && result.event == AccionesDialog.Eliminar) {
        this.deleteRowData(result.data);
      }
    });
  }

  openDialogDescripcion(idTipoBonificacion: number) {
    switch (idTipoBonificacion) {
      case TiposBonificaciones.Inmobiliaria:
        this.detalle = "La bonificación otorgada es asumida por la propia inmobiliaria."
        break;
      case TiposBonificaciones.InmobiliariaInquilino:
        this.detalle = "La bonificación otorgada es asumida en un %50 por la propia inmobiliaria y un %50 por el inquilino."
        break;
      case TiposBonificaciones.InmobiliariaPropietario:
        this.detalle = "La bonificación otorgada es asumida en un %100 por el propietario más el % de la comisión otorgada en el contrato."
        break;
      case TiposBonificaciones.Inquilinos:
        this.detalle = "La bonificación otorgada es asumida por la propia inmobiliaria."
        break;
      case TiposBonificaciones.Promociones:
        this.detalle = "La bonificación otorgada es asumida por la propia inmobiliaria."
        break;
      case TiposBonificaciones.Propietarios:
        this.detalle = "La bonificación otorgada es asumida en un %100 por el propietario"
        break;

      default:
        break;
    }
    this.dialog.open(DialogDescripcionComponent, {
      data: this.detalle,
    });
  }

  applyFilter(event: any) {
    if (event && event.target && event.target.value !== undefined) {
const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
}
  }


  addRowData(row_obj: { descripcion: any; tieneComision: boolean }) {
    this.spinner.show()
    let createKeyValueRequest = new CreateTipoBonificacionRequest
    createKeyValueRequest.descripcion = row_obj.descripcion
    createKeyValueRequest.tieneComision = !!row_obj.tieneComision

    let existe = false
    this.dataSource.data.forEach((element, index) => {
      if (element.descripcion === row_obj.descripcion)
        existe = true
    });

    if (createKeyValueRequest && !existe) {
      this.tiposBonificacionService.create(createKeyValueRequest)
        .subscribe(
          data => {
            this.spinner.hide()
            this.dataSource.data.push({
              id: data.id,
              descripcion: row_obj.descripcion,
              tieneComision: !!row_obj.tieneComision
            });
            this.table.renderRows();
            this.dataSource.data = this.dataSource.data.filter((value: { id: number; descripcion: string }, key: any) => {
              return true;
            });
            this.data = this.dataSource.data.length >= 1 ? true : false
            this.snackBar.showSuccess("Registro agregado correctamente.", "Exito");
          },
          error => {
            this.spinner.hide()
            this.snackBar.showError(error, "Error");
          }
        )
    }
    else {
      this.spinner.hide()
      this.snackBar.showWarn("El registro ya existe", "Error");
    }

  }
  updateRowData(row_obj: { id: number; descripcion: string; tieneComision: boolean }) {
    this.spinner.show()
    let updateKeyValueRequest = new UpdateTipoBonificacionRequest
    updateKeyValueRequest.id = row_obj.id
    updateKeyValueRequest.descripcion = row_obj.descripcion
    updateKeyValueRequest.tieneComision = !!row_obj.tieneComision

    // Se excluye el propio registro: si no, cambiar sólo "Genera comisión" sin tocar
    // la descripción daba "El registro ya existe".
    let existe = false
    this.dataSource.data.forEach((element, index) => {
      if (element.descripcion === row_obj.descripcion && element.id !== row_obj.id)
        existe = true
    });
    if (updateKeyValueRequest && !existe) {
      this.tiposBonificacionService.update(updateKeyValueRequest)
        .subscribe(
          data => {
            this.spinner.hide()
            this.dataSource.data = this.dataSource.data.filter((value: TipoBonificacionDto, key: any) => {
              if (value.id == row_obj.id) {
                value.descripcion = row_obj.descripcion;
                value.tieneComision = !!row_obj.tieneComision;
              }
              return true;
            });
            this.data = this.dataSource.data.length >= 1 ? true : false
            this.snackBar.showSuccess("Registro actualizado correctamente.", "Exito");
          },
          error => {
            this.spinner.hide()
            this.snackBar.showError(error, "Error");
          })
    }
    else {
      this.spinner.hide()
      this.snackBar.showWarn("El registro ya existe", "Error");
    }
  }

  deleteRowData(row_obj: { id: number; }) {
    this.dataSource.data = this.dataSource.data.filter((value: { id: number; }, key: any) => {
      return value.id != row_obj.id;
    });
    this.data = this.dataSource.data.length >= 1 ? true : false
  }

}
